// Mirrors the platform-wide country list. US is intentionally present without a
// matching Currency: Calo has no USD price list, so `getCurrencyFromCountry` falls
// back for it. Add USD to Currency here and in the backend before mapping it.
export enum Country {
  AE = 'AE',
  BH = 'BH',
  KW = 'KW',
  OM = 'OM',
  QA = 'QA',
  SA = 'SA',
  US = 'US',
  GB = 'GB'
}

export enum Currency {
  AED = 'AED',
  BHD = 'BHD',
  KWD = 'KWD',
  OMR = 'OMR',
  QAR = 'QAR',
  SAR = 'SAR',
  GBP = 'GBP'
}

export enum CelebrationType {
  REFERRAL = 'referral',
  PHONE_UPDATE = 'phoneUpdate',
  PHONE_VERIFICATION = 'phoneVerification'
}

export enum LoginMethod {
  PHONE = 'phone',
  EMAIL = 'email'
}

export enum PhoneUpdateStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

export enum ChallengeType {
  OTP = 'OTP',
  TOKEN = 'TOKEN',
  EMAIL_OTP = 'EMAIL_OTP',
  EMAIL_RESEND_OTP = 'EMAIL_RESEND_OTP',
  RESEND_OTP = 'RESEND_OTP'
}

export enum AffiliateCommissionType {
  PERCENTAGE = 'PERCENTAGE',
  FIXED = 'FIXED'
}

export enum AffiliateProfileStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED'
}

export enum AffiliateCreditReason {
  COUPON_USED = 'COUPON_USED',
  COUPON_USED_MIGRATION = 'COUPON_USED_MIGRATION',
  LIFETIME_DISCOUNT = 'LIFETIME_DISCOUNT',
  MANUAL = 'MANUAL'
}

export enum AffiliateCreditTransactionStatus {
  APPLIED = 'APPLIED',
  VOIDED = 'VOIDED'
}

export enum CompensationScheme {
  SUBSCRIPTION_CREDIT = 'subscriptionCredit',
  PAYOUT = 'payout'
}

export enum AffiliateTransactionType {
  PAYOUT = 'payout',
  REDEEMED = 'redeemed'
}

export enum AffiliatePayoutTransactionStatus {
  PENDING = 'pending',
  APPROVED = 'approved'
}
